import { useDispatch, useSelector } from 'react-redux';

// Thin aliases so components never import react-redux directly.
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
